import { action } from "satcheljs";
import { IPreviewSchedulePageStore } from "../store/PreviewSchedulePageStore";
import { GenerateOptions } from "../../smartSchedule/smartScheduleUtils";

export const openPreviewPage = action(
    "OPEN_PREVIEW_PAGE",
    (
        viewState: IPreviewSchedulePageStore,
        open: boolean,
        selectedTagId?: string,
        startDate?: string,
        endDate?: string,
        jobId?: string,
        generateOption?: GenerateOptions
    ) => ({
        viewState: viewState,
        selectedTagId: selectedTagId,
        open: open,
        startDate: startDate,
        endDate: endDate,
        jobId: jobId,
        generateOption: generateOption
    })
);

export default openPreviewPage;